import React from 'react';
import { Typography } from 'antd';
import PageTemplate from './PageTemplate';
import Login from './login';
import { useStateContext } from '../../contexts/ContextProvider';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { ROLES } from '../../config/permissions';
const { Title } = Typography;

function LoginPage() {
  const navigate = useNavigate();

  const { user, removeToken, verificaUtilizator } = useStateContext();

  // Navigare către dashboard (doar pentru utilizatori autentificați)
  const goToDashboard = async () => {
    try {
      // Verificăm utilizatorul cu token-ul existent
      const userData = await verificaUtilizator(true); // forțăm refresh-ul
      console.log("userData", userData);
      if (userData && userData.role === ROLES.ADMIN) {
        // Utilizatorul este valid, navigăm către dashboard
        navigate('/dashboard');
      } else if (userData && userData.role === ROLES.WITHOUT_ADMIN) {
        // Utilizatorul este valid, navigăm către dashboard
        navigate('/dashboard/oferte');
      } else {
        // Token invalid sau inexistent, afișăm modalul de login
        message.error('Token invalid sau inexistent');
      }
    } catch (error) {
      console.error("Eroare la verificarea utilizatorului:", error);
      // În caz de eroare, afișăm modalul de login
      message.error('Eroare la verificarea utilizatorului');
    }
  };



  const handleLoginSuccess = () => {
    // Această funcție va fi apelată după autentificarea cu succes
    console.log('Autentificare reușită');
    goToDashboard();
  };

  return (
    <PageTemplate>
      <div className="bg-white p-6 max-w-md mx-auto rounded-lg shadow-md">
        <Title level={2} className="text-center mb-6">Autentificare</Title>
        <Login onSuccess={handleLoginSuccess} />
      </div>
    </PageTemplate>
  );
}

export default LoginPage;
